export const shouldPurgeForDeletionResponse = (status, responseData) => (
  status === 202 && responseData?.success === true && responseData?.mandatoryPurge === true
) || (
  status === 401 && responseData?.mandatoryPurge === true
);
